import { Org } from '@weenat/client/dist/resources/orgs'
import { TKey, useIntl } from '@weenat/wintl'
import Text from 'app/src/kit/Text'
import { isNil } from 'lodash-es'
import UpgradeToPremiumButton from './UpgradeToPremiumButton'

const UpgradeToPremiumCTA: FC<{
  organization?: Org
  callToActionMessage?: TKey
  /** Already formatted */
  callToAction?: string
}> = ({ callToActionMessage, callToAction, organization }) => {
  const { t } = useIntl()

  return (
    <Box $py='2xl'>
      {!isNil(callToAction) || !isNil(callToActionMessage) ? (
        <Text $textAlign='center'>
          {!isNil(callToAction)
            ? callToAction
            : t(callToActionMessage || 'ecommerce.plans.essential.common_call_to_action', {
                plan: t('ecommerce.plans.plus.label')
              })}
        </Text>
      ) : null}
      <Flex $pt='2xl' $justifyContent='center'>
        <UpgradeToPremiumButton organizationId={organization?.id} />
      </Flex>
    </Box>
  )
}
export default UpgradeToPremiumCTA
